import React from 'react';
import { Tabs, Table, Icon, Divider, Dropdown, Button, Menu, Modal, Checkbox } from 'antd';
import { translate } from 'react-i18next';
import ModalLoggedSkill from '../../components/ModalLoggedSkill'
import ModalLoggedSkill_gallery from '../../components/ModalLoggedSkill_gallery'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'
import { yearChange } from '../../actions'
import { pathOr } from 'ramda';
const TabPane = Tabs.TabPane;

class SkillsLogged extends React.Component {

  state = {
    category: 'All',
    cluster: 'All',
    sortedInfo: null,
    modalData: {
      subject: "",
      category: "",
      cluster: "",
      level: "",
      filename: []
    },
    modalData_gallery: [],
    modalOpen: false,
    modalOpen_galery: false,
    checked: []
  }

  menuCategory = () => {
    const { t } = this.props;
    let categories;
    if (this.props.category) {
      categories = Object.entries(this.props.category)
        .map( category =>
          category[1].name
        )
    }
    return (
      <Menu style={styles.dropdown} onClick={(e) => this.setCategory(e.item.props.children)}>
        <Menu.Item key="all">{t('All')}</Menu.Item>
        {categories && categories.map( (category, i) =>
          <Menu.Item key={i}>{t(category)}</Menu.Item>
          )
        }
      </Menu>
    )
  }

  setCategory = (category) => {
    const { t } = this.props
    if (category == t('All')) {
      category = 'All'
    }
      this.setState({category, cluster: 'All'})
  }

  //Not using
  deleteField = (record) => {

    this.props.firebase.database().ref('logs/'+record.key).remove()
  }

  menuCluster = () => {
    const { t } = this.props;
    let clusters;
    if (this.props.cluster) {
      clusters = Object.entries(this.props.cluster)

      //Find ID of selected category
      let categoryId;
      if (this.state.category && this.state.category != 'All') {
        let categories = Object.entries(this.props.category)
        categoryId = categories.filter( category =>
          t(category[1].name) == this.state.category
        )
        categoryId = categoryId[0][0]
      }

      clusters = clusters.filter( cluster =>
        cluster[1].category == categoryId
        &&
        cluster[1].readOnly == false
      )

    }
    return (
      <Menu style={styles.dropdown} onClick={(e) => this.setState({cluster: e.item.props.children == t('All') ? 'All' : e.item.props.children})}>
        <Menu.Item key="all">{t('All')}</Menu.Item>
        {clusters && clusters.map( (cluster, i) =>
          <Menu.Item key={i}>{t(cluster[1].name)}</Menu.Item>
          )
        }
      </Menu>
    )
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({ sortedInfo: sorter });
  }

  closeModal = () => {
    this.setState({modalOpen: false})
  }

  checkRecord = (checked, record) => {
    let modalData_gallery = this.state.modalData_gallery
    let checked_ids = this.state.checked
    if (checked) {
    modalData_gallery.push(record)
    checked_ids.push(record.key)
    } else {
      modalData_gallery = modalData_gallery.filter( data =>
        data.key !== record.key
      )
      checked_ids = checked_ids.filter( key =>
        key !== record.key
      )
    }
    this.setState({modalData_gallery, checked: checked_ids})
  }

  render() {
    //Loop logs for table
    const { t, currentYear, allYears, gradeSelected } = this.props;
    const yearTabs = gradeSelected ? [{text: 'Selected class'}] : allYears

    let data = [];
    if (this.props.logs && this.props.students) {
      let logs = Object.entries(this.props.logs);

      logs.reverse()
      let students = Object.entries(this.props.students)
      logs.map( (log, index) => {

        let attachmentNames = []
        if (log[1].attachments) {
          if (typeof log[1].attachments === 'object') {
            attachmentNames.push(log[1].attachments)
          } else {
            let attachments = log[1].attachments;
            attachments.map( item =>
              attachmentNames.push([item.name, item.path])
            )
          }
        }
        let userid = log[1].user_id;

        let student = students.filter( item =>
          item[1][0] == userid
        )
        let name;


        if (student.length > 0) {
          name = student[0][1][1].profile.name+' '+student[0][1][1].profile.last_name
        } else {
          name = 'Unknown'
        }

        data.push(
          {
            key: log[1].id,
            name: t(name),
            subject: t((this.props.subjects && this.props.subjects[log[1].subject.id]) && this.props.subjects[log[1].subject.id].name),
            category: t(log[1].atl_category.name),
            cluster: t(log[1].atl_cluster.name),
    //      skills: log[1].skill.name,
            level: t(log[1].level_skill.name),
            date: t(log[1].date.slice(0,10)),
            files: <Icon style={{fontSize: '24px', opacity: attachmentNames.length != 0 ? 1 : 0.5}} type="file-text" />,
            attachments: log[1].attachments,
            notes: t(log[1].notes),
            skillCluster: pathOr('',['skillCluster', 'name'], log[1])
          }
        )
      })

      // Filter data
      if (this.state.category != 'All') {
        data = data.filter( entry =>
          entry.category == this.state.category
        )
        if (this.state.cluster != 'All') {
          data = data.filter( entry =>
            entry.cluster == this.state.cluster
          )
        }
      }
    }

    let sortedInfo = this.state.sortedInfo
    sortedInfo = sortedInfo || {};
    const columns = [
            {
              title: '',
              dataIndex: 'checkbox',
              key: 'checkbox',
              sorter: false,
              render: (text, record) => <Checkbox checked={this.state.checked.includes(record.key)} onChange={(e) => this.checkRecord(e.target.checked, record)} id="checkbox"></Checkbox>
            },
            {
              title: t('Name'),
              dataIndex: 'name',
              key: 'name',
              sorter: true,
              sorter: (a, b) => a.name.localeCompare(b.name),
              sortOrder: sortedInfo.columnKey === 'name' && sortedInfo.order,
            },
            {
              title: t('Subject'),
              dataIndex: 'subject',
              key: 'subject',
              sorter: true,
              sorter: (a, b) => a.subject.localeCompare(b.subject),
              sortOrder: sortedInfo.columnKey === 'subject' && sortedInfo.order,
            },
            {
              title: t('Skill Category'),
              dataIndex: 'category',
              key: 'category',
              sorter: true,
              sorter: (a, b) => a.category.localeCompare(b.category),
              sortOrder: sortedInfo.columnKey === 'category' && sortedInfo.order,
            },
            {
              title: t('Skill Cluster'),
              dataIndex: 'cluster',
              key: 'cluster',
              sorter: true,
              sorter: (a, b) => a.cluster.localeCompare(b.cluster),
              sortOrder: sortedInfo.columnKey === 'cluster' && sortedInfo.order,
            },
            {
              title: t('Level of Skill'),
              dataIndex: 'level',
              key: 'level',
              sorter: true,
              sorter: (a, b) => a.level.localeCompare(b.level),
              sortOrder: sortedInfo.columnKey === 'level' && sortedInfo.order,
            },
            {
              title: t('Skill Descriptor'),
              dataIndex: 'skillCluster',
              key: 'skillCluster',
              sorter: true,
              sorter: (a, b) => a.skillCluster.localeCompare(b.skillCluster),
              sortOrder: sortedInfo.columnKey === 'skillCluster' && sortedInfo.order,
            },
            {
              title: t('Files'),
              dataIndex: 'files',
              key: 'files',
            },
            {
              title: t('Date'),
              dataIndex: 'date',
              key: 'date',
              sorter: true,
              sorter: (a, b) => a.date.localeCompare(b.date),
              sortOrder: sortedInfo.columnKey === 'date' && sortedInfo.order,
            },
    ]


    return (
      <div>
        <div style={styles.container} className="card-container">
          <Tabs
            type="card"
            activeKey={currentYear.year && !gradeSelected  ? currentYear.year.text : 'Selected class'}
            onTabClick={(year) => !gradeSelected && this.props.changeYear(allYears.filter( item => item.text === year)[0])}
          >
          {yearTabs && yearTabs.map( year => (
            <TabPane
            style={styles.yearbox}
            tab={year.text}
            key={year.text}>
              <div>
                <Dropdown overlay={this.menuCategory()}>
                  <Button style={styles.button}>
                    {this.state.category == 'All' ? t('Category') : t(this.state.category)} <Icon type="down" />
                  </Button>
                </Dropdown>
                <Dropdown disabled={this.state.category == 'All'} overlay={this.menuCluster()}>
                  <Button style={styles.button}>
                    {this.state.cluster == 'All' ? t('Cluster') :  t(this.state.cluster)} <Icon type="down" />
                  </Button>
                </Dropdown>
                {/*
                <Dropdown overlay={menu}>
                  <Button style={styles.button}>
                    {t('Skills')} <Icon type="down" />
                  </Button>
                </Dropdown>
                */}
                <Button disabled={this.state.modalData_gallery.length == 0} style={styles.viewButton} onClick={() => this.setState({modalOpen_galery: true})}>{t('View')}</Button>
              </div>
              <Table
                onChange={this.handleChange}
                id='log-table'
                columns={columns}
                locale={{
                  emptyText: t('No Data')
                }}
                dataSource={data}
                onRow={(record) => {
                  return {
                    onClick: (e) => {e.target.id != "checkbox" && this.setState({modalData: record, modalOpen: true})},
                    //onClick: () => {this.deleteField(record)},
                  };
                }}
              />
            </TabPane>
          ))}
          </Tabs>
        </div>
        <ModalLoggedSkill isOpen={this.state.modalOpen} cancel={() => this.closeModal()} data={this.state.modalData} t={this.props.t} />
        {this.state.modalData_gallery &&
            <ModalLoggedSkill_gallery 
              isOpen={this.state.modalOpen_galery} 
              cancel={() => this.setState({modalOpen_galery: false})} 
              data={this.state.modalData_gallery} 
              t={this.props.t}
            />
        }
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'atl_category', 'atl_cluster', 'users', 'subjects'
    ]
  }),
  connect(
    state => ({
      logs: state.relevantLogs.logs,
      students: state.studentsOfSchool.students,
      category: state.firebase.data.atl_category || {},
      cluster: state.firebase.data.atl_cluster || {},
      subjects: state.firebase.data.subjects || {},
      currentYear: state.currentYear,
      allYears: state.allYears && state.allYears.years,
      gradeSelected: state.selectedClass.id == 'All' ? false : true
    }),
    {changeYear: yearChange}
  )
)
export default enhancer(SkillsLogged);

const styles = {

  yearbox: {
    backgroundColor: 'white',
    padding: '40px 20px'
  },

  container: {
    margin: '0px 20px 20px 20px',
  },

  button: {
    borderRadius: '25px',
    width: '200px',
    marginRight: '20px',
    marginBottom: '40px'
  },
  viewButton: {
    borderRadius: '25px',
    width: '170px',
    marginRight: '20px',
    marginBottom: '40px',
    float: 'right'
  },

}



// WEBPACK FOOTER //
// ./src/containers/SkillsLogged/index.jsx